import React from 'react';

export default function SearchIcon(props) {
  return (
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 3">
        <path id="Vector" d="M8.6012 1.92887C12.3594 1.92887 15.4395 4.98966 15.4395 8.76721C15.4395 12.5448 12.3788 15.6056 8.6012 15.6056C4.82364 15.6056 1.76286 12.5254 1.76286 8.76721C1.76286 5.00903 4.82364 1.92887 8.6012 1.92887ZM8.6012 0.166016C3.83567 0.166016 0 4.00168 0 8.76721C0 13.5327 3.83567 17.3684 8.6012 17.3684C13.3667 17.3684 17.2024 13.5327 17.2024 8.76721C17.2024 4.00168 13.328 0.166016 8.6012 0.166016Z" fill="#9747FF" />
        <path id="Vector_2" d="M19.7783 20.8351C19.5459 20.8351 19.3328 20.7383 19.1584 20.5833L13.4437 14.8685C13.095 14.5198 13.095 13.958 13.4437 13.6287C13.7923 13.28 14.3541 13.28 14.6835 13.6287L20.3982 19.3435C20.7469 19.6922 20.7469 20.254 20.3982 20.5833C20.2239 20.7576 20.0108 20.8351 19.7783 20.8351Z" fill="#9747FF" />
      </g>
    </svg>
  );
}
